module.exports = ".card-body12 {\n  height: calc(100vh - 190px); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mailing-list/component/mailing-page/mailing-page.component.sass
// module id = ./src/app/modules/mailing-list/component/mailing-page/mailing-page.component.sass
// module chunks = main